"use client"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRotateRight } from "@fortawesome/free-solid-svg-icons"
import { FaHandshake } from "react-icons/fa"

const ProductSidebar = ({
    product,
    isGetRateButtonDisabled,
    handleGetTodayRate,
    rateLoading,
    hasRequestedRateToday,
    handleManualRefresh,
    isRefreshing,
    isStep1Complete,
    rateRequestSent,
    currentRate,
    detailsChangedAfterRate,
    rateRequestDetails,
    rateDate,
    isNegotiating,
    setIsNegotiating,
    userOffer,
    setUserOffer,
    handleNegotiateSubmit,
    formatDate,
}) => {
    return (
        <div className="product-detail-container">
            {/* Left Sidebar */}
            <div className="product-sidebar">
                <img src={product.img || "/placeholder.svg"} alt={product.name} className="product-sidebar-image" />
                <h2 className="product-sidebar-name">{product.name || "Product Name"}</h2>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <button
                        className={`get-rate-btn ${isGetRateButtonDisabled() ? "disabled" : "active"}`}
                        onClick={handleGetTodayRate}
                        disabled={isGetRateButtonDisabled()}
                    >
                        {rateLoading ? "Requesting..." : hasRequestedRateToday() ? "Rate Requested" : "Get Today Rate"}
                    </button>

                    <button
                        className={`refresh-btn ${isRefreshing ? "spin" : ""}`}
                        onClick={handleManualRefresh}
                        title="Refresh Rate"
                    >
                        <FontAwesomeIcon icon={faRotateRight} />
                    </button>
                </div>

                {!isStep1Complete && <p className="fill-details-message">Note: Fill all details to get today's rate</p>}
                {hasRequestedRateToday() && !currentRate && (
                    <p className="fill-details-message">You've requested a rate for this grade at this site today.</p>
                )}

                {/* Rate information display */}
                {rateRequestSent && !currentRate && (
                    <div className="rate-notification">
                        <p>
                            You will be notified shortly with the latest rates. If the rates are not displayed, please refresh after
                            some time.
                        </p>
                    </div>
                )}

                {currentRate && !detailsChangedAfterRate && (
                    <div className="rate-display">
                        <div className="rate-bar">
                            <span className="rate-label">Today Rate: </span>
                            <span className="rate-value">₹{currentRate}</span>
                            {rateRequestDetails?.status !== "close" && (
                                <div className="negotiate-container">
                                    <button className="negotiate-btn" onClick={() => setIsNegotiating(true)} title="Negotiate Rate">
                                        <FaHandshake className="negotiate-icon" />
                                        <span className="negotiate-text">Negotiate</span>
                                    </button>
                                </div>
                            )}
                        </div>
                        {rateRequestDetails?.userOffer && rateRequestDetails?.status !== "close" && (
                            <div className="negotiation-card">
                                <div className="negotiation-row user-offer">
                                    <span className="label">💬 Your Offer</span>
                                    <span className="value">₹{rateRequestDetails.userOffer}</span>
                                </div>

                                <div className="negotiation-row supplier-offer">
                                    <span className="label">🏢 Supplier Offer</span>
                                    <span className="value">₹{currentRate}</span>
                                </div>
                            </div>
                        )}

                        {/* If Negotiation Closed → Show Final Offer */}
                        {rateRequestDetails?.status === "close" && (
                            <div className="negotiation-card">
                                <div className="negotiation-row final-offer">
                                    <span className="label">✅ Final Offer</span>
                                    <span className="value">₹{currentRate}</span>
                                </div>
                            </div>
                        )}

                        {rateDate && (
                            <div className="rate-date">
                                <small>as of {formatDate(rateDate)}</small>
                            </div>
                        )}
                        <div className="rate-disclaimer">
                            <small>*Rates are subject to change as per company regularly.</small>
                        </div>

                        {isNegotiating && (
                            <div className="negotiate-form">
                                <input
                                    type="number"
                                    className="negotiate-input"
                                    placeholder={`₹${currentRate}`}
                                    value={userOffer}
                                    onChange={(e) => setUserOffer(e.target.value)}
                                    onWheel={(e) => {
                                        e.target.blur();
                                    }}
                                />
                                <button className="negotiate-submit" onClick={handleNegotiateSubmit}>
                                    Submit Offer
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {currentRate && detailsChangedAfterRate && (
                    <div className="rate-warning">
                        <p>Details have changed since rate request.</p>
                        <p>Rate is specific to the original details.</p>
                        <p>Please get a new rate or revert to original details.</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProductSidebar
